import styled from 'styled-components'

import { Modal } from 'antd'

export const Card = styled(Modal)`
  width: 450px !important;
  height: 300px !important;
  padding-top: -200px;

  .ant-modal-body {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    width: 450px !important;
    height: 300px !important;
  }

  .ant-modal-title {
    font-size: 23px;
  }
`
